export const QA_DESCOPE_PROJECT_ID = 'P32AChDvEswJtnBOsX26vHeCXTws';

export type WebAuthnCapabilityOutcome =
  | 'frontend_capable'
  | 'public_key_credential_missing'
  | 'credentials_get_missing'
  | 'credentials_create_missing';

export const getWebAuthnCapabilityOutcome = (): WebAuthnCapabilityOutcome => {
  if (typeof window.PublicKeyCredential === 'undefined') {
    return 'public_key_credential_missing';
  }

  if (typeof navigator.credentials?.get !== 'function') {
    return 'credentials_get_missing';
  }

  if (typeof navigator.credentials?.create !== 'function') {
    return 'credentials_create_missing';
  }

  return 'frontend_capable';
};

export const browserSupportsWebAuthn = (): boolean =>
  getWebAuthnCapabilityOutcome() === 'frontend_capable';

export const browserSupportsConditionalMediation =
  async (): Promise<boolean> => {
    const conditionalMediationCheck =
      window.PublicKeyCredential?.isConditionalMediationAvailable;

    if (typeof conditionalMediationCheck !== 'function') {
      return false;
    }

    try {
      return await conditionalMediationCheck.call(window.PublicKeyCredential);
    } catch {
      return false;
    }
  };
